import { render, staticRenderFns } from "./ProfileEmployeeOnboard.vue?vue&type=template&id=1ed89ec2&"
import script from "./ProfileEmployeeOnboard.vue?vue&type=script&lang=js&"
export * from "./ProfileEmployeeOnboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports